import type React from 'react';

import styles from './ImageToolbar.module.scss';

export interface ImageToolbarProps {
    children?: React.ReactNode;
}

/**
 * The row of controls above the image.
 *
 * It used to own its children's toggle state in the DOM: a ref callback ran
 * `querySelectorAll('button')` over the subtree, set `aria-pressed` on every named button
 * it found, and attached a click listener - never removed - that flipped the attribute.
 * Nothing in React knew about any of it, which is why the toolbar's stylesheet needed
 * eleven `!important`s to win, and why the fullscreen button had to set `aria-pressed`
 * back to false by hand: the native listener sat on an ancestor and fired first.
 *
 * Now it is only a container. Each toggle renders its own `aria-pressed` from the state it
 * already owns, via Button's `pressed` prop, and each panel trigger its `aria-expanded`
 * through Menu.
 *
 * The wrapper `<div>` per child is load-bearing, not decoration: the button skin in
 * ImageToolbar.module.scss is scoped `> div button`.
 */
export default function ImageToolbar(props: ImageToolbarProps) {
    const { children } = props;

    return <div className={styles.imageToolbar}>{children}</div>;
}
